export default __webpack_public_path__ + "static/media/2269.42df5b97.png";